import type { PhaseInformationWidget } from "@/lib/types/MatterPhase";

/** Built-in presentation types accepted by the Phase Project contract. */
export const PHASE_WIDGET_CATALOG: {
  type: PhaseInformationWidget["type"];
  title: string;
  description: string;
  wide: boolean;
}[] = [
  {
    type: "Countdown",
    title: "Phase countdown",
    description:
      "Days remaining from the phase's first progress. Choose the duration; reopening keeps the original start date.",
    wide: false,
  },
  {
    type: "LiabilityCoverage",
    title: "Liability & coverage",
    description:
      "Incident report status and sentiment, policy-limit confirmation, coverage, and liability details by carrier.",
    wide: false,
  },
  {
    type: "TreatmentSummary",
    title: "Treatment summary",
    description:
      "Total medical bills, payments, and outstanding treatment balances. Receipt checks remain individual phase actions.",
    wide: true,
  },
  {
    type: "SentDemands",
    title: "Sent demands",
    description:
      "Sent demand amounts, coverage, accepted offers, adjuster contact controls, and expiration timelines.",
    wide: true,
  },
  {
    type: "Coverage",
    title: "Coverage",
    description:
      "Third-party and first-party coverage, policy limits, liability, and carrier details.",
    wide: true,
  },
  {
    type: "TreatmentTimeline",
    title: "Treatment timeline",
    description:
      "Provider appointments and treatment history on a visual timeline.",
    wide: true,
  },
  {
    type: "Providers",
    title: "Providers",
    description:
      "Medical providers, appointments, records, and outstanding balances.",
    wide: true,
  },
  {
    type: "SettlementSummary",
    title: "Settlement & disbursement summary",
    description:
      "Final settlement, fees, costs, and net proceeds to the client.",
    wide: true,
  },
  {
    type: "CycleTimeSummary",
    title: "Cycle time summary",
    description: "Time on desk and time spent in each matter status.",
    wide: true,
  },
  {
    type: "FinalLienResolutions",
    title: "Final lien resolutions",
    description:
      "Original and final lien and medical bill amounts by provider or payer.",
    wide: true,
  },
];

export function createPhaseInformationWidget(
  type: PhaseInformationWidget["type"],
): PhaseInformationWidget {
  const definition = PHASE_WIDGET_CATALOG.find(
    (widget) => widget.type === type,
  );
  if (!definition) throw new Error(`Unknown phase widget type: ${type}`);
  const base = {
    id: crypto.randomUUID(),
    title: definition.title,
    actionDefinitionIds: [],
  };
  return type === "Countdown"
    ? { ...base, type, durationDays: 30 }
    : { ...base, type };
}
